// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__35QGO","right":"Footer_right__3XxZ3","buttons":"Footer_buttons__3QFBg"};